package dairy.mynotes.reusablecomponents

import androidx.compose.material3.Icon
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.vector.ImageVector
import dairy.mynotes.ui.theme.AppColors
import mynotes.composeapp.generated.resources.Res
import mynotes.composeapp.generated.resources.ic_my_notes_logo
import mynotes.composeapp.generated.resources.notes
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.painterResource

@Composable
fun ImageIcon(drawableResource: DrawableResource = Res.drawable.notes,
              modifier: Modifier = Modifier,
              color: Color = AppColors.PrimaryVariant,
              contentDescription: String? = null) {
    Icon(
        painter = painterResource(drawableResource),
        contentDescription = contentDescription,
        modifier = modifier,
        tint = color
    )
}


